import Api from "../api";
// Interfaces and Definitions
export var WorkflowStatus = /*#__PURE__*/ function (WorkflowStatus) {
    WorkflowStatus[WorkflowStatus["Idle"] = 0] = "Idle";
    WorkflowStatus[WorkflowStatus["Executing"] = 1] = "Executing";
    WorkflowStatus[WorkflowStatus["Finished"] = 2] = "Finished";
    WorkflowStatus[WorkflowStatus["Faulted"] = 3] = "Faulted";
    WorkflowStatus[WorkflowStatus["Aborted"] = 4] = "Aborted";
    return WorkflowStatus;
}({});
export var PropertiesType = /*#__PURE__*/ function (PropertiesType) {
    PropertiesType["text"] = "text";
    PropertiesType["list"] = "list";
    PropertiesType["select"] = "select";
    PropertiesType["expression"] = "expression";
    PropertiesType["boolean"] = "boolean";
    PropertiesType["variable"] = "variable";
    PropertiesType["variablePicker"] = "variablePicker";
    return PropertiesType;
}({});
export var ActivityType = /*#__PURE__*/ function (ActivityType) {
    ActivityType["start"] = "Start";
    ActivityType["finish"] = "Finish";
    return ActivityType;
}({});
// Endpoins
var basePathDefinition = "/workflow-definition";
var basePathInstance = "/workflow-instance";
function DefinitionGetAll(request) {
    return Api.post("".concat(basePathDefinition, "/v2"), request);
}
function DefinitionNew() {
    return Api.get("".concat(basePathDefinition, "/create"));
}
function DefinitionCreate(model) {
    return Api.post("".concat(basePathDefinition, "/create"), model);
}
function DefinitionEdit(id) {
    return Api.get("".concat(basePathDefinition, "/edit/").concat(id));
}
function DefinitionSaveEdit(id, model) {
    return Api.post("".concat(basePathDefinition, "/edit/").concat(id), model);
}
function DefinitionDisable(id, disable) {
    return Api.post("".concat(basePathDefinition, "/disable/").concat(id, "/").concat(disable));
}
function DefinitionDelete(id) {
    return Api["delete"]("".concat(basePathDefinition, "/delete/").concat(id));
}
function DefinitionDuplicate(id) {
    return Api.get("".concat(basePathDefinition, "/duplicate/").concat(id));
}
function DefinitionPublish(id) {
    return Api.post("".concat(basePathDefinition, "/publish/").concat(id));
}
function InstanceGetAll(request) {
    return Api.post("".concat(basePathInstance, "/getAll"), request);
}
function InstanceDetails(id) {
    return Api.get("".concat(basePathInstance, "/details/").concat(id));
}
function InstanceResume(id) {
    return Api.get("".concat(basePathInstance, "/resume/").concat(id));
}
function InstanceDelete(id) {
    return Api["delete"]("".concat(basePathInstance, "/delete/").concat(id));
}
function InstanceFinish(id) {
    return Api.get("".concat(basePathInstance, "/finish/").concat(id));
}
function PdfReport(correlationId) {
    return Api.get("".concat(basePathInstance, "/PdfReport/").concat(correlationId, "?listAll=true"), {
        responseType: 'blob'
    });
}
function PdfReportByTask(taskId) {
    return Api.get("".concat(basePathInstance, "/PdfReportByTask/").concat(taskId), {
        responseType: 'blob'
    });
}
export { DefinitionCreate, DefinitionDelete, DefinitionDisable, DefinitionDuplicate, DefinitionEdit, DefinitionGetAll, DefinitionNew, DefinitionPublish, DefinitionSaveEdit, InstanceDelete, InstanceDetails, InstanceFinish, InstanceGetAll, InstanceResume, PdfReport, PdfReportByTask };
